import script from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsEdit.vue?vue&type=style&index=0&id=d9c8a154&lang=scss"

const __exports__ = script;

export default __exports__